import Constants from '@/Constants';
import { PushNotificationRequest } from '@/models/PushNotificationRequest';
import http from '@/services/HttpService';
import { AxiosRequestConfig } from 'axios';
import { call, put } from 'redux-saga/effects';
import { PayloadAction } from 'typesafe-actions';
import {
    allPushNotificationListSuccess,
    getPushNotificationListFailure,
    uncheckedPushNotificationListSuccess,
    updatePushNotificationStatusFailure,
    updatePushNotificationStatusSuccess,
} from './action';
import { PushNotificationTypes } from './types';

export function* getPushNotificationListRequest(
    action: PayloadAction<PushNotificationTypes.GET_PUSH_NOTIFICATION_LIST_REQUEST, PushNotificationRequest>,
) {
    try {
        const { paginationData, newer, lastId, uncheckedOnly } = action.payload;
        let queryParams: string = `?offset=${paginationData.offset}&limit=${paginationData.limit}`;

        if (newer !== undefined) {
            queryParams += `&newer=${newer}`;
        }

        if (lastId !== undefined) {
            queryParams += `&lastId=${lastId}`;
        }

        if (uncheckedOnly !== undefined) {
            queryParams += `&uncheckedOnly=${uncheckedOnly}`;
        }

        const request: AxiosRequestConfig = { headers: { requestSuccessType: paginationData.requestSuccessType } };
        const response = yield call(http.get, Constants.MESSAGE_NOTIFICATIONS_URI + queryParams, request);

        switch (request.headers.requestSuccessType) {
            case PushNotificationTypes.ALL_PUSH_NOTIFICATION_LIST_SUCCESS:
                yield put(allPushNotificationListSuccess(response.data, response.headers.total));
                break;
            case PushNotificationTypes.UNCHECKED_PUSH_NOTIFICATION_LIST_SUCCESS:
                yield put(uncheckedPushNotificationListSuccess(response.data, response.headers.total));
                break;
            default:
                break;
        }
    } catch (error) {
        yield put(getPushNotificationListFailure());
    }
}

export function* updatePushNotificationStatusRequest(action: PayloadAction<PushNotificationTypes.UPDATE_PUSH_NOTIFICATION_STATUS, number>) {
    try {
        yield call(http.put, Constants.MESSAGE_CHECK_NOTIFICATION_URI.replace('%n', action.payload.toString()), action.payload);
        yield put(updatePushNotificationStatusSuccess(action.payload));
    } catch (error) {
        yield put(updatePushNotificationStatusFailure());
    }
}
